<template>
    <div id="solution_type_mc" class="px-3 px-sm-0">
        <div v-if="solutions" class="espMcCheck">
            <v-checkbox
                v-for="(sol, index) in solutions"
                :key="index"
                v-model="selected"
                :value="sol"
                hide-details
                :disabled="hasUserInput"
                :class="{
                    espMcCheckBlack: isChecked(sol),
                    correctAnswer: spot.raetsel.user_input_json && checkIfAnswerIsCorrect(sol),
                    wrongAnswer: spot.raetsel.user_input_json && isChecked(sol) && !checkIfAnswerIsCorrect(sol)
                }"
            >
                <template #prepend>
                    <span
                        class="pa-4 pa-md-2 text-sm-h6"
                        :class="[
                            isChecked(sol) ? 'black--text espMcCheckBlack' : 'grey--text',
                            {
                                espMcCheckBlack: isChecked(sol),
                                correctAnswerIcon: spot.raetsel.user_input_json && checkIfAnswerIsCorrect(sol),
                                wrongAnswerIcon: spot.raetsel.user_input_json && isChecked(sol) && !checkIfAnswerIsCorrect(sol)
                            }
                        ]"
                        >{{ printToLetter(index + 1) }}</span
                    >
                </template>
                <template #label>
                    <span :class="[
                        'espMCText', 'pa-4',  
                        {
                            espMcCheckBlack: isChecked(sol),
                            correctAnswerIcon: spot.raetsel.user_input_json && checkIfAnswerIsCorrect(sol),
                            wrongAnswerIcon: spot.raetsel.user_input_json && isChecked(sol) && !checkIfAnswerIsCorrect(sol),
                            'black--text': isChecked(sol)
                        }
                        ]">{{ sol }}</span>
                </template>
                <template #append>
                    <v-icon
                        class="pa-4"
                        v-if="isChecked(sol)"
                        dense
                        color="black"
                        :class="{
                            espMcCheckBlack: isChecked(sol),
                            correctAnswerIcon: spot.raetsel.user_input_json && checkIfAnswerIsCorrect(sol),
                            wrongAnswerIcon: spot.raetsel.user_input_json && isChecked(sol) && !checkIfAnswerIsCorrect(sol)
                        }"
                        >mdi-check-circle</v-icon
                    >
                </template>
            </v-checkbox>
            <!-- Hint -->
            <div
                v-if="hasMcCondition && mcHint"
                class="px-1 py-5 text-subtitle-1"
                :style="{'backgroundColor': theme.backgroundColor, 'color': theme.textColor }"
            >
                <v-icon class="pr-2" :color="theme.textColor">mdi-alert-circle</v-icon>{{ mcHint }}
            </div>
        </div>
    </div>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';
import { solutionMixin } from '@/utils/solution-mixin';
export default {
    mixins: [layoutMixin, solutionMixin],
    props: {
        spot: {},
        color: {},
        selectedColorCss: {},
        borderColor: {},
        solutionTypeMcCorrect: {},
        solutionTypeMcWrong: {}
    },
    data() {
        return {
            selected: [],
            valid: null,
            answerCorrect: false,
            answerWrong: false,
            colorValue: this.color,
            selectedColorValue: this.selectedColorCss,
            borderColorValue: this.borderColor,
            solutionTypeMcCorrectValue: this.solutionTypeMcCorrect,
            solutionTypeMcWrongValue: this.solutionTypeMcWrong,
        };
    },
    mounted() {
        this.assignPseudoElementStyle();
    },
    computed: {
        hasMcCondition() {
            return this.maxVotes > 1;
        },
        userInputCount() {
            return this._.isArray(this.selected) ? this.selected.length : 0;
        },
        mcHintCount() {
            return this.hasMcCondition ? this.maxVotes - this.userInputCount : 0;
        },
        isMcExact() {
            return this.spot && this.spot.raetsel && this.spot.raetsel.max_votes_exact;
        },
        maxVotes() {
            return this.spot && this.spot.raetsel && this.spot.raetsel.max_votes ? this.spot.raetsel.max_votes : 0;
        },
        mcHint() {
            if (this.mcHintCount > 0) {
                return this.$tc('solveMcMissingAnswers', this.mcHintCount, {
                    count: this.mcHintCount,
                    task: this.$t('task')
                });
            } else if (this.isMcExact && this.userInputCount != this.maxVotes) {
                return this.$tc('solveMcFull', this.maxVotes, {
                    count: this.maxVotes
                });
            }
            return '';
        }
    },
    watch: {
        /* Init data on creation and on update */
        spot: {
            handler() {
                if (this.hasUserInput) {
                    this.selected = this.userInput;
                }
            },
            immediate: true,
            deep: true
        },
        selected() {
            let validInput = this.hasValidMcInput();
            let serverInput = validInput ? this.getServerData(this.selected) : null;
            let input = validInput ? this.selected : [];
            this.$emit('input', input, serverInput);
        }
    },
    methods: {
        hasValidMcInput() {
            if (this.spot && this.spot.raetsel && this.selected) {
                if (this.spot.raetsel.max_votes <= 0 && !this.spot.raetsel.max_votes_exact) {
                    return true;
                }
                if (this.spot.raetsel.max_votes_exact && this.selected.length == this.spot.raetsel.max_votes) {
                    return true;
                }
                if (
                    !this.spot.raetsel.max_votes_exact &&
                    this.spot.raetsel.max_votes > 0 &&
                    this.selected.length <= this.spot.raetsel.max_votes
                ) {
                    return true;
                }
            }
            return false;
        },
        isChecked(sol) {
            return this._.includes(this.selected, sol);
        },
        selectedColor(sol) {
            return this.isChecked(sol) ? 'black' : 'grey';
        },
        printToLetter(number) {
            let alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let result = '';
            if (this._.isNumber(number)) {
                let charIndex = number % alphabet.length;
                let quotient = number / alphabet.length;
                if (charIndex - 1 == -1) {
                    charIndex = alphabet.length;
                    quotient--;
                }
                result = alphabet.charAt(charIndex - 1) + result;
                if (quotient >= 1) {
                    result = this.printToLetter(parseInt(quotient)) + result;
                }
            }
          return result;
        },
        checkIfAnswerIsCorrect(solution) {
            if (this.spot && this.spot.raetsel) {
                if (this.isChecked(solution)) {
                    const correct = this.spot.raetsel.ralsgtyp === 6 || this.spot.raetsel.lsg_correct.find(element => element === solution);
                    if (correct) {
                        this.answerCorrect = true;
                        return true;
                    } else {
                        this.answerWrong = true;
                        return false;
                    }
                } else {
                    const correct = this.spot.raetsel.lsg_correct.find(element => element == solution);
                    if (correct) {
                        this.answerCorrect = true;
                        return true;
                    }
                }
            }
        },
        assignPseudoElementStyle() {
            this.colorValue = this.theme.textColor;
            this.selectedColorValue = this.theme.btnColorPrimary;
            this.borderColorValue = this.theme.textColor;
            this.solutionTypeMcCorrectValue = this.theme.btnColorPrimary;
            this.solutionTypeMcWrongValue =  this.theme.btnSecondary;
            document.documentElement.style.setProperty('--border-color', this.borderColorValue);
            document.documentElement.style.setProperty('--color', this.colorValue);
            document.documentElement.style.setProperty('--selected-color', this.selectedColorValue);
            document.documentElement.style.setProperty('--selected-color', this.selectedColorValue);
            document.documentElement.style.setProperty('--solution-type-mc-correct', this.solutionTypeMcCorrectValue);
            document.documentElement.style.setProperty('--solution-type-mc-wrong', this.solutionTypeMcWrongValue);
        }
    }
};
</script>

<style lang="scss">
#solution_type_mc {
    .espMcCheck .v-input--selection-controls__input {
        display: none !important;
    }
    .text-sm-h6{
        @media (min-width: 600px) and (max-width: 969px) {
            line-height: 1rem !important;
        }
    }
    .espMcCheck .v-input--checkbox {
        border: solid 2px var(--border-color);
        border-radius: 10px;
        -moz-border-radius: 10px;
        -webkit-border-radius: 10px;
        >div{
            padding-bottom: 5px;
        }
    }
    .espMcCheck .espMcCheckBlack.v-input--checkbox {
        border-color: var(--selected-color);
    }
    .espMCText {
        border-left: 2px solid var(--border-color);
    }

    .espMCText.espMcCheckBlack {
        border-color: var(--selected-color);
    }

    .espMcCheck .espMcCheckBlack .v-input__append-outer > .v-icon {
        color: var(--selected-color) !important; /* doesnt work because it is isabled*/
    }

    .espMcCheck {
        .correctAnswer {
            &.v-input--checkbox {
                border-color: var(--solution-type-mc-correct);
            }
        }
        .wrongAnswer {
            &.v-input--checkbox {
                border-color: var(--solution-type-mc-wrong);
            }
        }
        .espMcCheckBlack {
            .v-icon {
                &.correctAnswerIcon {
                    color: var(--solution-type-mc-correct) !important;
                }
                &.wrongAnswerIcon {
                    color: var(--solution-type-mc-wrong) !important;
                }
            }
            &.correctAnswerIcon {
                border-color: var(--solution-type-mc-correct) !important;
            }
            &.wrongAnswerIcon {
                border-color: var(--solution-type-mc-wrong) !important;
            }
        }
        .espMCText {
            &.correctAnswerIcon {
                border-color: var(--solution-type-mc-correct);
            }
        }
    }

    .grey--text {
       color: var(--border-color) !important;
    }
    .black--text {
        color: var(--border-color) !important;
    }

    span {
        color: var(--border-color);
    }
}
</style>
